import React from 'react';
import { connect } from 'react-redux';

import { PS_BONUS_INCOMING } from 'apps/auth/constants/Constants';

import BillCheque from './BillCheque';
import HistoryCheque from './HistoryCheque';
import TopUpBonusCheque from './TopUpBonusCheque';

const SendCheque = (props) => {
    const cheque = props.cheque;
    if (cheque.billId !== 0) {
        return <BillCheque getFormattedChequeDate={props.getFormattedChequeDate} />;
    } else if (cheque.transactionType === PS_BONUS_INCOMING) {
        return <TopUpBonusCheque getFormattedChequeDate={props.getFormattedChequeDate} />;
    } else {
        return <HistoryCheque getFormattedChequeDate={props.getFormattedChequeDate} setModal={props.setModal} />;
    }
};
const mapStateToProps = (state) => ({
    cheque: state.history.cheque.cheque,
});

export default connect(mapStateToProps)(SendCheque);
